export default __webpack_public_path__ + "static/media/Imperial-Fleet-00.1a23f51a.jpg";